import axios from 'axios';

const Sparcal = {
  postPasswordReset: async (data) => {
    const headers = {
      'Content-Type': 'application/json',
    };
    const dataset = await axios
      .post(
        `${process.env.REACT_APP_API_URL}/Auth/forget_password?email=${data.email}`,
        headers
      )
      .then((resp) => {
        return { status: resp.status, message: resp.data.message };
      })
      .catch((err) => {
        return { status: err.status, message: err.message };
      });
    return dataset;
  },
  getDraftDataset: async (user) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + user.access_token,
    };
    const dataset = await axios
      .get(`${process.env.REACT_APP_API_URL}/ckan/draft-packages?rows=400`, {
        headers: headers,
      })
      .then((resp) => {
        return resp;
      })
      .catch((err) => {
        return { status: err.status, message: err.message };
      });
    return dataset;
  },
  getUserDraftDataset: async (user) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + user.access_token,
    };
    const dataset = await axios
      .get(
        `${process.env.REACT_APP_API_URL}/ckan/my-draft-packages?&rows=400`,
        {
          headers: headers,
        }
      )
      .then((resp) => {
        return resp;
      })
      .catch((err) => {
        return { status: err.status, message: err.message };
      });
    return dataset;
  },
  createDataset: async (user, data) => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.access_token,
    };
    try {
      const dataset = await axios
        .post(`${process.env.REACT_APP_API_URL}/ckan/package`, data, {
          headers: headers,
        })
        .then((resp) => {
          return resp;
        })
        .catch((err) => {
          return { status: err.status, message: err.message };
        });

      return dataset;
    } catch (e) {
      console.error(e, 'Error creating dataset');
    }
  },
  deleteDataset: async (user, package_id) => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.access_token,
    };
    try {
      const dataset = await axios
        .delete(`${process.env.REACT_APP_API_URL}/ckan/package/${package_id}`, {
          headers: headers,
        })
        .then((resp) => {
          return { status: resp.status, message: resp.data.message };
        })
        .catch((err) => {
          return { status: err.status, message: err.message };
        });

      return dataset;
    } catch (e) {
      console.error(e, 'Error deleting dataset');
    }
  },
  approveDataset: async (user, package_id) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + user.access_token,
    };
    try {
      const dataset = await axios
        .post(
          `${process.env.REACT_APP_API_URL}/ckan/approve-draft/${package_id}`,
          {},
          {
            headers: headers,
          }
        )
        .then((resp) => {
          return { status: resp.status, message: resp.data.message };
        })
        .catch((err) => {
          return { status: err.status, message: err.message };
        });

      return dataset;
    } catch (e) {
      console.error(e, 'Error deleting dataset');
    }
  },
  denyDataset: async (user, package_id) => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.access_token,
    };
    try {
      const dataset = await axios
        .delete(
          `${process.env.REACT_APP_API_URL}/ckan/deny-draft/${package_id}`,
          {
            headers: headers,
          }
        )
        .then((resp) => {
          return { status: resp.status, message: resp.data.message };
        })
        .catch((err) => {
          return { status: err.status, message: err.message };
        });

      return dataset;
    } catch (e) {
      console.error(e, 'Error deleting dataset');
    }
  },
  shapefileToGeojson: async (zip) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Utility/convert/shapefile_to_geojson`,
        zip,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );
      return response;
    } catch (error) {
      console.error('Upload failed:', error.response?.data || error.message);
      return error;
    }
  },
  getSLDForBoundary: async (url, layer) => {
    try {
      const params = {
        SERVICE: 'WMS',
        VERSION: '1.1.1',
        REQUEST: 'GetStyles',
        LAYERS: layer,
      };
      const dataset = await axios
        .get(url, {
          params,
        })
        .then((resp) => {
          return resp;
        })
        .catch((err) => {
          return { status: err.status, message: err.message };
        });

      return dataset;
    } catch (e) {
      console.error(e, 'Error get data');
    }
  },
};
export default Sparcal;
